var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 0H0v36h36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M10.204 22.896q.312 0 .622.036c.56-1.77 2.242-2.98 4.149-2.984.475 0 .946.076 1.395.226 1.11-2.331 3.743-3.598 6.326-3.045 2.585.553 4.424 2.777 4.422 5.345 0 .444-.057.886-.169 1.317 2.462.364 4.221 2.506 4.038 4.918-.183 2.411-2.246 4.28-4.736 4.291H10.204C7.33 33 5 30.738 5 27.948s2.33-5.053 5.204-5.053m0 9.262h16.047c2.138.009 3.885-1.655 3.917-3.73s-1.663-3.79-3.801-3.842a.44.44 0 0 1-.346-.183.41.41 0 0 1-.05-.38c.86-2.39-.42-5.01-2.873-5.874-2.453-.865-5.166.347-6.086 2.717a.43.43 0 0 1-.241.243.45.45 0 0 1-.347-.007 3.5 3.5 0 0 0-1.45-.312c-1.65.003-3.07 1.132-3.4 2.701a.433.433 0 0 1-.51.33 4.5 4.5 0 0 0-.86-.083c-2.395 0-4.337 1.885-4.337 4.21s1.942 4.21 4.337 4.21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 25v-7.5c6-1.5 19.559-3.461 19-1.5-.5 1.756-2.333 4-3 4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    fillRule: "evenodd",
    d: "M14.624 12.78h-.847a4.56 4.56 0 0 0-4.561 4.562v8.507a2.897 2.897 0 0 0 5.794 0v-11.62c.008-1.159.517-1.45.772-1.45z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M17.07 17.286c-.464-.052-.88-.45-1.03-.644v6.116c5.858 1.094 8.884-3.734 9.206-4.25.322-.514 1.48-3.025.708-2.124-.618.721-1.502.902-1.867.902-2.146.021-6.554.051-7.017 0M11.147 11.62c-.36 0-1.266.687-1.674 1.03.837-4.635 5.601-6.888 7.597-6.63 1.596.206 2.21 1.545 2.317 2.189.022 1.48.052 4.352 0 3.991-.051-.36-.922-.536-1.352-.58z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M20.61 8.209c0-.773-.643-1.653-.965-1.996 4.828.901 6.566 5.73 6.566 7.468 0 1.39-1.416 2.21-2.124 2.446-1.438.021-4.262.051-4.056 0 .206-.052.472-.708.58-1.03z"
  })));
};
export default SvgCloud;